import { Image } from '@marriott/mi-ui-library';
import {
  CenterContentGrid,
  ButtonRow,
  Card,
  Description,
  Title,
  StyledButton,
  EnrollmentCardContent,
  FloatingCardContent,
} from './EnrollmentCard.styles';
import type { EnrollmentCardProps } from './EnrollmentCard.types';

export function EnrollmentCard({
  className,
  header,
  description,
  children,
  variation,
  buttons,
  image,
}: EnrollmentCardProps) {
  return (
    <Card className={className} $variation={variation}>
      {image ? (
        <Image
          altText={image.altText}
          renditions={image.dynamicMedia?.renditions}
          defaultImageURL={image.fileReferenceImage}
          customClass="enrollment-image"
        />
      ) : null}
      <FloatingCardContent>
        <EnrollmentCardContent>
          <Title $variation={variation}>{header}</Title>
          <Description $variation={variation}>{description}</Description>
          {children ? <CenterContentGrid>{children}</CenterContentGrid> : null}
          <ButtonRow>
            {buttons
              ?.filter(button => button.buttonCopy)
              .map((props, index) => (
                <StyledButton isLink key={index} {...props} />
              ))}
          </ButtonRow>
        </EnrollmentCardContent>
      </FloatingCardContent>
    </Card>
  );
}
